import React from 'react'

import { Form, Col } from '_zari/core'

import { Select2CuentaContable } from 'sharedComponents/select2'
import { ClearInputGroup } from 'sharedComponents/utils'

const CuentaContableUSDFormGroup = ({ iError, iTouched, iReadonlyInfo, setFieldValue }) => {
  const clickClear = React.useCallback(() => {
    setFieldValue('cuentaContableUSD', '')
    setFieldValue('nombreCuentaContableUSD', '')
  }, [setFieldValue])

  const onChangeCuenta = React.useCallback(
    sel => {
      setFieldValue('cuentaContableUSD', sel.value)
      setFieldValue('nombreCuentaContableUSD', sel.label)
    },
    [setFieldValue]
  )

  return (
    <Form.Group>
      <Form.Label text='CUENTA USD' htmlFor='input-cuentaContableUSD' md={4} alignRightAt='md' />
      <Col md={8}>
        {iReadonlyInfo ? (
          <ClearInputGroup id='readonly-cuentaContableUSD' iValue={iReadonlyInfo} clickClear={clickClear} />
        ) : (
          <Select2CuentaContable onlyAnalitica onChange={onChangeCuenta} />
        )}
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(CuentaContableUSDFormGroup)
